import { useMutation } from "@tanstack/react-query";
import { api } from "lib/api";
import { usePerfilSettings } from "../settings/store";

export function useUpdateMiFamilia() {
  const perfil = usePerfilSettings();

  return useMutation({
    mutationFn: (patch) =>
      api("/perfil/familia", {
        method: "PATCH",
        body: JSON.stringify(patch),
      }),
    onSuccess: () => {
      perfil.invalidateContext();
    },
  });
}
